<div class="legend-layer" *ngIf="legendInfo">
  <strong *ngIf="showTitle" [class.out-of-scale]="!legendInfo.isInScale">{{legendInfo.layer.title}}</strong>
  <img *ngIf="urlWithOptions" [alt]="failedToLoadMessage + ' ' + legendInfo.layer.title" [src]="urlWithOptions" [srcset]="srcset" />
</div>
